import chatsContainerRedux from 'Modules/chat/views/chatsContainer/redux/slice';
import teamChatListRedux from 'Modules/chat/views/chatTypes/team/redux/listSlice';
import chatThreadRedux from 'Modules/chat/views/chatThread/redux/slice';
import chatListContactsRedux from 'Modules/chat/views/chatTypes/team/redux/contactsSlice';
import aiChatListRedux from 'Modules/chat/views/chatTypes/ai/redux/aiChatListSlice';
import supportMessageListRedux from 'Modules/chat/views/chatTypes/support/redux/messageSlice';
import supportChatListRedux from 'Modules/chat/views/chatTypes/support/redux/supportChannelsSlice';

export default {
  chatListContactsRedux,
  chatsContainerRedux,
  teamChatListRedux,
  chatThreadRedux,
  aiChatListRedux,
  supportMessageListRedux,
  supportChatListRedux,
};
